export enum METHOD {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export const METHOD_OPTIONS: any[] = [
  {
    label: METHOD.GET,
    value: METHOD.GET,
  },
  {
    label: METHOD.POST,
    value: METHOD.POST,
  },
  {
    label: METHOD.PUT,
    value: METHOD.PUT,
  },
  {
    label: METHOD.DELETE,
    value: METHOD.DELETE,
  }
];

export const DEFAULT_API_REQ_VALUE: any = {
  "headers": {
    "Content-Type": "application/json"
  },
  "params": {},
  "json": {}
}
